var map = {
	"./01_limit.json": "+dFG",
	"./02_connect.json": "hDC3",
	"./03_data_compress.json": "YUWz",
	"./04_heart_beat.json": "Ze9p",
	"./05_cancel_subscribe.json": "hlb8",
	"./06_subscribe.json": "g2tG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "yx4H";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/spot/websocket/introduce \.json$
// module id = yx4H
// module chunks = 3